// extracted by mini-css-extract-plugin
export default {"tooltip":"style_tooltip__60TAr","left":"style_left__NBG5l","top":"style_top__5asmM","right":"style_right__6KDxl","bottom":"style_bottom__1WnGc"};